import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ABTestState {
  variant: string | null;
}

const initialState: ABTestState = {
  variant: null,
};

const abTestSlice = createSlice({
  name: 'abTest',
  initialState,
  reducers: {
    setVariant: (state, action: PayloadAction<string | null>) => {
      state.variant = action.payload;
    },
    clearVariant: (state) => {
      state.variant = null;
    },
  },
});

export const { setVariant, clearVariant } = abTestSlice.actions;
export default abTestSlice.reducer;

